export default "__VITE_ASSET__CsXLsA3A__"